import { Observable } from "rxjs";
import { Action } from "@ngrx/store";
import * as productActions from "./product.actions";
import { Facets } from "../shared/interface/facets";
import { FacetsGroup } from "../shared/interface/facets1";
import { ProductDetails } from "../shared/interface/product-details";
import { ProductSearchCriteria } from "../shared/interface/product-search-criteria";
import { ProductCompare } from "../shared/interface/product-compare";
import { RetailInfo } from "../shared/interface/retail-info";
import { FeaturedProduct } from "../shared/interface/featured-product";
import { HeaderInfo } from "../shared/interface/header/header-info";
export interface ProductState {
  productFilterSuperSet: Facets[];
  productFilter: Facets[];
  productFilterGroup: FacetsGroup[];
  productFilterGroupSuperSet: FacetsGroup[];
  productSearch: string;
  productSort: any;
  productFeatured: FeaturedProduct;
  productDetails: ProductDetails[];
  productParams: ProductSearchCriteria;
  productLoading: boolean;
  productCompare: ProductCompare[];
  totalProducts: number;
  paginationParams: {
    page: number;
    limit: number;
  };
  retailInfo: RetailInfo;
  retailInfoLoading: boolean;
  globalHeader: object;
  subBrandHeader: object;
  suggestedProduct: {
    productDetails: ProductDetails[];
    totalProducts: number;
    search: null;
  };
  locale: string;
  isFeaturedProductIncludedInCount: boolean;
  productCategoriesSuperset: Facets[];
}

export const initialState: ProductState = {
  productFilterSuperSet: [],
  productFilter: [],
  productFilterGroup: [],
  productFilterGroupSuperSet: [],
  productSearch: "",
  productSort: [],
  productFeatured: null,
  totalProducts: 0,
  productDetails: [],
  productParams: {
    page: 1,
    limit: 9,
    locale: "",
  },
  productLoading: false,
  productCompare: initProductCompare(),
  paginationParams: {
    page: 0,
    limit: 0,
  },
  retailInfo: null,
  retailInfoLoading: false,
  globalHeader: {},
  subBrandHeader: {},
  suggestedProduct: {
    productDetails: [],
    totalProducts: 0,
    search: null,
  },
  locale: "",
  isFeaturedProductIncludedInCount: false,
  productCategoriesSuperset: initProductCategories(),
};

function initProductCompare(): ProductCompare[] {
  try {
    let productCompare: ProductCompare[] = JSON.parse(
      localStorage.getItem(getCurLocale() + "-compareProduct")
    );
    if (productCompare) {
      return productCompare;
    }
  } catch (e) {}
  return [null, null, null, null];
}

function initProductCategories() {
  try {
    let productCategories = JSON.parse(
      localStorage.getItem(getCurLocale() + "-productCategories")
    );
    if (productCategories) {
      return productCategories;
    }
  } catch (e) {}
  return [];
}

function getCurLocale(): string {
  return window.location.pathname.split("/")[1];
}

export function reducer(state = initialState, action): ProductState {
  switch (action.type) {
    case productActions.ActionTypes.LOAD_PRODUCT: {
      return Object.assign({}, state, {
        productLoading: true,
      });
    }
    case productActions.ActionTypes.LOAD_PRODUCT_FILTER: {
      return Object.assign({}, state, {
        productLoading: true,
        productFilterSuperSet: state.productFilterSuperSet,
      });
    }

    case productActions.ActionTypes.LOAD_PRODUCT_CATEGORY: {
      return Object.assign({}, state, {
        productLoading: true,
        productFilterSuperSet: state.productFilterSuperSet,
      });
    }

    case productActions.ActionTypes.LOAD_PRODUCT_COMPLETE: {
      let product = action.payload.body.results.q1;
      let catProducts = action.payload.body.results.q0.products;
      let superFilters = action.payload.body.results.q0.aggregations;
      let categories = initProductCategories();
      let queryParameters = action.payload.queryParams;
      let filteredCategories =
        state.productCategoriesSuperset &&
        state.productCategoriesSuperset.length
          ? state.productCategoriesSuperset
          : categories && categories.filterValues
          ? [categories]
          : getValidProductFiltersSuperset(
              Object.keys(product.aggregations).filter((val) => {
                val !== "totalCount";
              }),
              queryParameters,
              state
            ).filter((arr) => arr.displayName == "category")[0];

      let productsListwithinfo = createProductInfo(
        product.products.length
          ? product.products
          : queryParameters.category &&
            queryParameters.category == "Desktop Workstation"
          ? catProducts
          : product.products
      );

      let productDetailsList = getProductDetailsWithCompare(
        productsListwithinfo,
        state.productCompare
      );
      let suggestedProducts = getProductDetailsWithCompare(
        createProductInfo(action.payload.body.results.q2.products),
        state.productCompare
      );
      let featuredProducts = getFeaturedProduct(suggestedProducts, state);
      let totalProducts = product.aggregations["totalCount"].buckets[0]
        ? product.aggregations["totalCount"].buckets[0].doc_count
        : 0;
      let productListFinal =
        queryParameters.page > 1
          ? addMoreProducts(
              state,
              product,
              productDetailsList,
              state.productCompare
            )
          : productDetailsList;
      let validProducts = featuredProducts
        ? productListFinal.filter(
            (product) =>
              product.productVariationName !==
              featuredProducts.productVariationName
          )
        : productListFinal;
      return Object.assign({}, state, {
        // getProductFilterSuperSet:getFiltersSuperSet(state,action.payload),
        productFilter: getValidProductFilters(
          product.aggregations,
          queryParameters,
          state,
          filteredCategories,
          superFilters
        ),
        productFilterGroup: getValidFilterGroup(
          product.aggregations.distinctGroupFamily.buckets.length
            ? product.aggregations.distinctGroupFamily
            : superFilters.distinctGroupFamily,
          state,
          queryParameters,
          superFilters.distinctGroupFamily
        ),
        productCategoriesSuperset: filteredCategories,
        productSearch: queryParameters.search ? queryParameters.search : "",
        productSort: action.payload.sort,
        totalProducts: totalProducts,
        isFeaturedProductIncludedInCount: true,
        productFeatured: featuredProducts,
        productDetails: validProducts,

        // productDetails: productDetailsList,
        suggestedProduct:
          totalProducts === 0 && suggestedProducts.length
            ? Object.assign({}, state.suggestedProduct, {
                productDetails: getSuggestedProductsWithCompare(
                  suggestedProducts,
                  state.productCompare
                ),
                totalProducts: 0,
              })
            : totalProducts === 0 && suggestedProducts.length == 0
            ? {
                productDetails: getSuggestedProductsWithCompare(
                  createProductInfo(
                    action.payload.body.results.q0.products.filter(
                      (x, index) => index < 3
                    )
                  ),
                  state.productCompare
                ),
                totalProducts: 0,
                search: null,
              }
            : {
                productDetails: [],
                totalProducts: 0,
                search: null,
              },
        productLoading: false,
        ...(Object.keys(queryParameters).length! >= 3 && {
          productFilterSuperSet: getValidProductFiltersSuperset(
            product.aggregations,
            queryParameters,
            state
          ),
          productFilterGroupSuperSet: getValidFilterGroup(
            product.aggregations.distinctGroupFamily,
            state,
            queryParameters,
            superFilters.distinctGroupFamily
          ),
        }),
      });
    }

    case productActions.ActionTypes.LOAD_PRODUCT_FILTER_COMPLETE: {
      let product = action.payload.body;

      return Object.assign({}, state, {
        productFilterSuperSet: getValidProductFiltersSuperset(
          product.aggregations,
          action.payload.queryParams,
          state
        ),
        productFilterGroupSuperSet: getValidFilterGroup(
          product.aggregations.distinctGroupFamily,
          state,
          action.payload.queryParams,
          {}
        ),
      });
    }

    case productActions.ActionTypes.LOAD_PRODUCT_CATEGORY_COMPLETE: {
      let product = action.payload.body.results
        ? action.payload.body.results.q0
        : action.payload.body;
      let categories = action.payload.body.results
        ? action.payload.body.results.q1
        : action.payload.body;
      let cat_filter =
        categories && categories.aggregations
          ? [
              getValidProductFiltersSuperset(
                categories.aggregations,
                action.payload.queryParams,
                state
              ).filter((arr) => arr.displayName == "category")[0],
            ]
          : state.productCategoriesSuperset;
      saveProductCategories(cat_filter);
      return Object.assign({}, state, {
        // productCategoriesSuperset: cat_filter,
        // productFilterSuperSet: getValidProductFiltersSuperset(
        //   product.aggregations,
        //   action.payload.queryParams,
        //   state
        // ),
        // productFilterGroupSuperSet: getValidFilterGroup(
        //   product.aggregations.distinctGroupFamily,
        //   state,
        //   action.payload.queryParams
        // ),
      });
    }

    case productActions.ActionTypes.UPDATE_PRODUCT_PARAMS: {
      let payload = action.payload;
      return {
        ...state,
        productParams: updateProductParams(
          state.productParams,
          payload,
          state.productFilter[2]
        ),
      };
    }

    case productActions.ActionTypes.ADD_COMPARED_PRODUCT: {
      let payload, singleProduct, newProductCompare, obj;

      payload = action.payload;
      if (payload.type === 0) {
        singleProduct = state.productFeatured;
        newProductCompare = addToProductCompare(
          state.productCompare,
          singleProduct
        );
        if (newProductCompare) {
          if (singleProduct) {
            obj = toggleAddRemoveCompare(
              [singleProduct],
              singleProduct.upc,
              true
            );
            if (obj.found) {
              return Object.assign({}, state, {
                productFeatured: obj.newProducts[0], //productFeatured is not an array, so get newProducts[0]
                productCompare: newProductCompare,
              });
            }
          }
          return Object.assign({}, state, {
            productCompare: newProductCompare,
          });
        }
      } else if (payload.type === 1) {
        singleProduct = state.suggestedProduct.productDetails.filter(
          (product) => product.upc === payload.upc
        )[0];
        newProductCompare = addToProductCompare(
          state.productCompare,
          singleProduct
        );
        if (newProductCompare) {
          if (singleProduct) {
            obj = toggleAddRemoveCompare(
              state.suggestedProduct.productDetails,
              singleProduct.upc,
              true
            );
            if (obj.found) {
              return Object.assign({}, state, {
                suggestedProduct: Object.assign({}, state.suggestedProduct, {
                  productDetails: obj.newProducts,
                }),
                productCompare: newProductCompare,
              });
            }
          }
          return Object.assign({}, state, {
            productCompare: newProductCompare,
          });
        }
      } else {
        singleProduct = state.productDetails.filter(
          (product) => product.upc === payload.upc
        )[0];
        newProductCompare = addToProductCompare(
          state.productCompare,
          singleProduct
        );
        if (newProductCompare) {
          if (singleProduct) {
            obj = toggleAddRemoveCompare(
              state.productDetails,
              singleProduct.upc,
              true
            );
            if (obj.found) {
              return Object.assign({}, state, {
                productDetails: obj.newProducts,
                productCompare: newProductCompare,
              });
            }
          }
          return Object.assign({}, state, {
            productCompare: newProductCompare,
          });
        }
      }
      return Object.assign({}, state);
    }

    case productActions.ActionTypes.REMOVE_COMPARED_PRODUCT: {
      let payload, singleProduct, newProductCompare, obj;

      payload = action.payload;
      newProductCompare = removeFromProductCompare(
        state.productCompare,
        payload
      );
      if (newProductCompare) {
        singleProduct = state.productFeatured;
        if (singleProduct && singleProduct.upc === payload) {
          obj = toggleAddRemoveCompare([singleProduct], payload, false);
          if (obj.found) {
            return Object.assign({}, state, {
              productFeatured: obj.newProducts[0], //productFeatured is not an array, so get newProducts[0]
              productCompare: newProductCompare,
            });
          }
        }

        singleProduct = state.suggestedProduct.productDetails.filter(
          (product) => product.upc === payload
        )[0];
        if (singleProduct) {
          obj = toggleAddRemoveCompare(
            state.suggestedProduct.productDetails,
            singleProduct.upc,
            false
          );
          if (obj.found) {
            return Object.assign({}, state, {
              suggestedProduct: Object.assign({}, state.suggestedProduct, {
                productDetails: obj.newProducts,
              }),
              productCompare: newProductCompare,
            });
          }
        }

        singleProduct = state.productDetails.filter(
          (product) => product.upc === payload
        )[0];
        if (singleProduct) {
          obj = toggleAddRemoveCompare(
            state.productDetails,
            singleProduct.upc,
            false
          );
          if (obj.found) {
            return Object.assign({}, state, {
              productDetails: obj.newProducts,
              productCompare: newProductCompare,
            });
          }
        }
        return Object.assign({}, state, {
          productCompare: newProductCompare,
        });
      }
      return Object.assign({}, state);
    }

    case productActions.ActionTypes.LOAD_RETAIL_INFO: {
      return Object.assign({}, state, {
        retailInfoLoading: true,
      });
    }

    case productActions.ActionTypes.LOAD_RETAIL_INFO_COMPLETE: {
      let retailInfo = action.payload;
      return Object.assign({}, state, {
        retailInfo: retailInfo,
        retailInfoLoading: false,
      });
    }

    case productActions.ActionTypes.LOAD_HEADER_INFO_COMPLETE: {
      let payload = action.payload;
      return Object.assign({}, state, {
        globalHeader: payload.NVIDIAglobalHeader[0],
        subBrandHeader: payload.NVIDIAsubBrandHeader[0],
      });
    }

    case productActions.ActionTypes.UPDATE_PRODUCT_PARAMS_ONLOAD: {
      let payload = action.payload;
      return Object.assign({}, state, {
        productParams: payload,
      });
    }

    case productActions.ActionTypes.LOAD_LOCALE: {
      let payload = action.payload;
      return Object.assign({}, state, {
        locale: payload,
        productParams: Object.assign({}, state.productParams, {
          locale: payload,
        }),
      });
    }

    case productActions.ActionTypes.CLEAR_PRODUCT_FILTER_SELECTION: {
      let payload = action.payload;
      return Object.assign({}, state, {
        productParams: payload,
      });
    }

    default: {
      return state;
    }
  }
}

function addMoreProducts(state, product, productDetails, productCompare) {
  let addProducts = [...state.productDetails, ...productDetails];
  return getProductDetailsWithCompare(addProducts, productCompare);
}

function getProductDetailsWithCompare(productDetails, productCompare) {
  return productDetails.map((productDetail) => {
    let result = productCompare.filter(
      (productCompare) =>
        productCompare !== null && productCompare.upc === productDetail.upc
    );
    if (result.length > 0) {
      return Object.assign({}, productDetail, {
        addRemoveCompare: "Remove",
      });
    }
    return Object.assign({}, productDetail, {
      addRemoveCompare: "Compare",
    });
  });
}

const getPrdStatus = (status, statusname) => {
  // switch(status){
  //   case 75:
  //     return 'nv_notify_me';
  //   case 76:
  //     return 'buy_now';
  //   case 77:
  //     return 'customize_buy';
  //   case 78:
  //     return 'dr_notify_me';
  //   case 79:
  //     return 'upcoming';
  //   case 80:
  //     return 'oos';
  //   default:
  //     return 'nv_notify_me';

  // }

  switch (statusname) {
    case "Check Availability":
      return "buy_now";
    case "NV Notify Me":
      return "nv_notify_me";
    default:
      return "buy_now";
  }
};
function createProductInfo(products) {
  return products.map((productDetail) => {
    let info = [
      {
        name: "gpu",
        value: productDetail.productName,
      },
      {
        name: "display_type",
        value: productDetail.screenSize
          ? productDetail.screenSize + " | " + productDetail.screenDisplayType
          : "--",
      },
      {
        name: "cpu_processor",
        value: productDetail.cpuProcessor,
      },
      {
        name: "memory",
        value:
          (productDetail.sysMemorySize ? productDetail.sysMemorySize : "") +
          " " +
          (productDetail.sysMemoryType
            ? productDetail.sysMemoryType
            : // ? productDetail.sysMemoryType.split("-")[0]
              ""),
      },
      {
        name: "storage",
        value: productDetail.hdStorageSize,
      },
    ];
    return Object.assign({}, productDetail, {
      prdStatus: getPrdStatus(productDetail.status, productDetail.statusName),
      productInfo: info,
      compareProductInfo: info,
    });
  });
}

function getSuggestedProductsWithCompare(
  suggestedProductDetails,
  productCompare
) {
  return suggestedProductDetails.map((suggestedProductDetail) => {
    let result = productCompare.filter(
      (productCompare) =>
        productCompare !== null &&
        productCompare.upc === suggestedProductDetail.upc
    );
    if (result.length > 0) {
      return Object.assign({}, suggestedProductDetail, {
        isSuggested: true,
        addRemoveCompare: "Remove",
      });
    }
    return Object.assign({}, suggestedProductDetail, {
      isSuggested: true,
      addRemoveCompare: "Compare",
    });
  });
}

function getFiltersSuperSet(state, data) {
  if (state.productFilterSuperSet.length) {
    return state.productFilterSuperSet;
  } else {
    // new ProductService.(data.queryParams, true)
    // fetch(new ProductService.environments[this.origin] + '/products/v3/search', {
    //     method: 'POST', // or 'PUT'
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(data.queryParams),
    //   })
    //   .then(response => {return response.json()})
    //   .then(data => {
    //   })
    //   .catch((error) => {
    //     console.error('Error:', error);
    //   });
  }
}
function allValuesSame(productCompare) {
  for (var i = 1; i < productCompare.length; i++) {
    if (productCompare[i] !== productCompare[0]) return false;
  }
  return true;
}

function toggleAddRemoveCompare(products, upc, isCompare) {
  let i, found, product, newProducts, label;

  found = false;
  newProducts = products.slice(0);
  label = isCompare ? "Compare" : "Remove";
  for (i = 0; i < newProducts.length; i++) {
    product = newProducts[i];
    if (product.upc === upc && product.addRemoveCompare === label) {
      newProducts[i] = Object.assign({}, product, {
        addRemoveCompare: isCompare ? "Remove" : "Compare",
      });
      found = true;
      break;
    }
  }
  return { found: found, newProducts: newProducts };
}

function addToProductCompare(productCompare, singleProduct) {
  let arr = productCompare.slice(0);
  let i = arr.indexOf(null);
  if (i >= 0) {
    arr.splice(i, 1, singleProduct);
    saveProductCompare(arr);
    return arr;
  }
  return null;
}

function removeFromProductCompare(productCompare, upc) {
  let i = productCompare
    .map((item) => {
      if (item) {
        return item.upc;
      }
      return null;
    })
    .indexOf(upc);

  if (i >= 0) {
    let arr = [
      ...productCompare.slice(0, i),
      ...productCompare.slice(i + 1, productCompare.length),
      null,
    ];
    saveProductCompare(arr);
    return arr;
  }
  return null;
}

function saveProductCompare(productCompare) {
  try {
    localStorage.setItem(
      getCurLocale() + "-compareProduct",
      JSON.stringify(productCompare)
    );
  } catch (e) {}
}

function saveProductCategories(productCategories) {
  try {
    localStorage.setItem(
      getCurLocale() + "-productCategories",
      JSON.stringify(productCategories)
    );
  } catch (e) {}
}

function getFeaturedProduct(products, state) {
  let featuredProduct = products.filter((product) => product.isFeatured);
  if (!featuredProduct) {
    return false;
  } else {
    return featuredProduct[0];
  }

  // let result = state.productCompare.filter(productCompare => productCompare !== null && (productCompare.upc === featuredProduct.upc));
  // if (result.length) {
  // 	return Object.assign({}, featuredProduct, {
  // 		isFeatured: true,
  // 		addRemoveCompare: 'Remove'
  // 	});
  // }
  // return Object.assign({}, featuredProduct, {
  //   isFeatured: true,
  //     addRemoveCompare: 'Compare'
  //   });
  // }
}

function updateProductParams(allParams, payload, priceFilter) {
  if (
    payload &&
    payload.fieldType !== "search" &&
    payload.fieldType !== "sort" &&
    payload.fieldType !== "searchSort"
  ) {
    if (
      allParams &&
      allParams.hasOwnProperty("gpu") &&
      !payload.trueValue &&
      payload.trueValue !== undefined
    ) {
      var paramCopy = allParams;
      for (var i in allParams) {
        if (i.indexOf("_filter") !== -1) {
          paramCopy = Object.assign(omit(allParams, i));
        }
      }
      var arrayUrl = payload.values.dispValue.split(",");
      var _gpuValues = paramCopy[payload.displayName];
      arrayUrl.forEach((element) => {
        //paramCopy[payload.displayName] = paramCopy[payload.displayName].split(',').filter(item => item !== element).join(',');
        _gpuValues = _gpuValues
          .split(",")
          .filter((item) => item !== element)
          .join(",");
      });
      //paramCopy[payload.displayName] = _gpuValues;
      //if(paramCopy[payload.displayName]==''){
      if (_gpuValues == "") {
        return Object.assign({}, paramCopy, {
          [payload.displayName]: _gpuValues,
          [payload.filterField]: "",
        });
      }
      return Object.assign({}, paramCopy, {
        [payload.displayName]: _gpuValues, //paramCopy[payload.displayName],
        [payload.filterField]:
          payload.fieldType === "checkbox"
            ? getAllFilterValues(payload.filterValues)
            : payload.filterValues.toString(),
      });
    }

    if (allParams && allParams.hasOwnProperty(payload.displayName)) {
      if (payload.fieldType === "checkbox" && payload.trueValue) {
        let d = allParams;
        for (var i in allParams) {
          if (i.indexOf("_filter") !== -1) {
            d = Object.assign(omit(allParams, i));
          }
        }
        if (payload.displayName === "category") {
          return Object.assign({}, d, {
            [payload.displayName]:
              d[payload.displayName] === ""
                ? payload.values.dispValue
                : payload.values.dispValue,
          });
        }
        return Object.assign({}, d, {
          [payload.displayName]:
            d[payload.displayName] === ""
              ? payload.values.dispValue
              : d[payload.displayName] + "," + payload.values.dispValue,
          [payload.filterField]:
            payload.fieldType === "checkbox"
              ? getAllFilterValues(payload.filterValues)
              : payload.filterValues.toString(),
        });
      } else if (payload.fieldType === "checkbox" && !payload.trueValue) {
        if (
          allParams[payload.displayName]
            .split(",")
            .filter((item) => item !== payload.values.dispValue)
            .join(",") === ""
        ) {
          let c = Object.assign(omit(allParams, payload.displayName));
          //c = omit(c, 'price');
          //c = omit(c, 'price_filter');
          // let d = Object.assign(omit(c, (payload.displayName + '_filter')));
          // return d;
          for (var i in c) {
            let d;
            if (i.indexOf("_filter") !== -1) {
              d = Object.assign(omit(c, i));
              if (
                !d.hasOwnProperty("manufacturer") &&
                !d.hasOwnProperty("gpu") &&
                !d.hasOwnProperty("price_filter") &&
                d.hasOwnProperty("price") &&
                [
                  priceFilter.defaultMinRangeVal,
                  priceFilter.defaultMaxRangeVal,
                ].toString() === d.price
              ) {
                d = Object.assign(omit(omit(c, "price"), i));
              }
              if (
                !d.hasOwnProperty("manufacturer") &&
                !d.hasOwnProperty("gpu") &&
                d.hasOwnProperty("price_filter") &&
                d.hasOwnProperty("price") &&
                d.price === d.price_filter
              ) {
                d = Object.assign(
                  omit(omit(omit(c, "price_filter"), "price"), i)
                );
              }
              return d;
            }
          }
          if (
            !c.hasOwnProperty("manufacturer") &&
            !c.hasOwnProperty("gpu") &&
            [
              priceFilter.defaultMinRangeVal,
              priceFilter.defaultMaxRangeVal,
            ].toString() === c.price
          ) {
            c = Object.assign(omit(c, "price"));
          }
          return c;
        } else {
          let d = allParams;
          for (var i in allParams) {
            if (i.indexOf("_filter") !== -1) {
              d = Object.assign(omit(allParams, i));
            }
          }
          return Object.assign({}, d, {
            [payload.displayName]: d[payload.displayName]
              .split(",")
              .filter((item) => item !== payload.values.dispValue)
              .join(","),
            [payload.filterField]:
              payload.fieldType === "checkbox"
                ? getAllFilterValues(payload.filterValues)
                : payload.filterValues.toString(),
          });
        }
      } else {
        if (
          payload.values[0] === payload.defaultMinRangeVal &&
          payload.values[1] === payload.defaultMaxRangeVal &&
          !allParams.hasOwnProperty("manufacturer") &&
          !allParams.hasOwnProperty("gpu") &&
          !allParams.hasOwnProperty("search") &&
          !allParams.search
        ) {
          return omit(
            omit(allParams, payload.displayName),
            payload.displayName + "_filter"
          );
        }
        return Object.assign({}, allParams, {
          [payload.displayName]: payload.values[0] + "," + payload.values[1],
          [payload.filterField]:
            payload.defaultMinRangeVal + "," + payload.defaultMaxRangeVal,
        });
      }
    } else {
      for (var i in allParams) {
        let c;
        if (i.indexOf("_filter") !== -1) {
          c = Object.assign(omit(allParams, i));
          return Object.assign({}, c, {
            [payload.displayName]:
              payload.fieldType === "checkbox"
                ? payload.values.dispValue
                : payload.values.toString(),
            [payload.filterField]:
              payload.fieldType === "checkbox"
                ? getAllFilterValues(payload.filterValues)
                : [
                    payload.defaultMinRangeVal,
                    payload.defaultMaxRangeVal,
                  ].toString(),
          });
        }
      }
      if (payload.fieldType === "checkbox") {
        if (payload.tab) {
          return Object.assign({}, allParams, {
            // [payload.displayName]: payload.values.dispValue,
            // [payload.filterField]: getAllFilterValues(payload.filterValues),
            tab: payload.tab,
            // persona:payload.persona,
            personaType: payload.personaType,
          });
        }
        return Object.assign({}, allParams, {
          [payload.displayName]: payload.values.dispValue,
          // [payload.filterField]: getAllFilterValues(payload.filterValues),
          [payload.personaType]: payload.personaType,
        });
      } else if (
        payload.fieldType === "range" &&
        (payload.values[0] !== payload.defaultMinRangeVal ||
          payload.values[1] !== payload.defaultMaxRangeVal)
      ) {
        return Object.assign({}, allParams, {
          [payload.displayName]: payload.values.toString(),
          [payload.filterField]: payload.filterValues.toString(),
        });
      } else {
        return allParams;
      }
    }
  } else {
    if (payload && payload.fieldType === "searchSort") {
      return Object.assign({}, allParams, {
        search: payload.values[0].value,
        sorting: payload.values[1].value,
      });
    } else {
      if (payload && payload.fieldType === "sort") {
        return Object.assign({}, allParams, {
          sorting: payload.value,
        });
      }
      if (payload && payload.fieldType === "search") {
        let c;
        if (!payload.value) {
          c = Object.assign(omit(omit(allParams, "search"), "sorting"));
          return c;
        }
        c = Object.assign(omit(allParams, "sorting"));
        return Object.assign({}, c, {
          search: payload.value,
        });
      }
    }
  }
}
function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

function getValidProductFiltersSuperset(filters, queryParams, state) {
  console.log("getValidProductFiltersSuperset");
  var filterArr = [];
  filters
    ? Object.keys(filters)
        .filter((key) => key != "totalCount")
        .map((key) => {
          // let params = new URLSearchParams(document.location.search);

          let filterName = key.split("distinct")[1];
          //  let search = params.get(filterName);
          let filterData = filters[key];
          let filterObj = {};

          if (filterName.includes("Category") && !queryParams.category) {
            filterObj = {
              displayName: "category",
              filterField: "category_filter",
              fieldType: "checkbox",
              checked: false,
              displayMaxValues: "8",
              units: null,
              showCount: false,
              filterDisplayOrder: 1,
              filterValues: filterData.buckets.map((name) => {
                return {
                  dispValue: name.key,
                  units: name.doc_count,
                  checked: queryParams["category"] == name.key,
                  groupType: null,
                  imageURL: null,
                };
              }),
            };
          }
          if (filterName.includes("Category") && queryParams.category) {
            let categorySuperset =
              state.productCategoriesSuperset &&
              state.productCategoriesSuperset.length
                ? state.productCategoriesSuperset[0]
                : state.productCategoriesSuperset;
            filterObj = {
              displayName: "category",
              filterField: "category_filter",
              fieldType: "checkbox",
              checked: false,
              displayMaxValues: "8",
              units: null,
              showCount: false,
              filterDisplayOrder: 1,
              filterValues:
                categorySuperset && categorySuperset.filterValues
                  ? categorySuperset.filterValues.map((cat) => {
                      return {
                        ...cat,
                        checked: queryParams["cateogry"] == cat.dispValue,
                      };
                    })
                  : filterData.buckets.map((name) => {
                      return {
                        dispValue: name.key,
                        units: name.doc_count,
                        checked: queryParams["category"] == name.key,
                        groupType: null,
                        imageURL: null,
                      };
                    }),
            };
          } else if (filterName.includes("MaxQSize")) {
            filterObj = {
              displayName: "max_q",
              filterField: "max_q_filter",
              fieldType: "checkbox",
              checked: true,
              displayMaxValues: "8",
              units: null,
              showCount: false,
              dataType: "Boolean",
              filterDisplayOrder: 7,
              filterValues: filterData.buckets.map((maxq) => {
                return {
                  dispValue: "1",
                  dispValueDesription: "max_q_description",
                  groupType: null,
                  units: 0,
                  checked: false,
                  imageURL: null,
                };
              }),
            };
          } else if (filterName.includes("GroupFamily")) {
            let gpuFilters = [];
            filterData.buckets.map((outerBucket) => {
              return outerBucket.distinctProductFamilyName.buckets.map(
                (innerBucket) => {
                  gpuFilters.push({
                    dispValue: innerBucket.key,
                    dispValueDesription: null,
                    groupType: outerBucket.key,
                    units: 0,
                    checked: false,
                    imageURL: null,
                  });
                }
              );
            });
            filterObj = {
              displayName: "gpu",
              filterField: "gpu_filter",
              fieldType: "checkbox",
              checked: true,
              displayMaxValues: "8",
              units: null,
              showCount: false,
              filterValues: gpuFilters,
            };
          } else if (filterName.includes("ScreenSize")) {
            filterObj = {
              displayName: filterName,
              filterField: filterName + "_filter",
              fieldType: "checkbox",
              checked: true,
              displayMaxValues: "8",
              units: null,
              showCount: false,
              filterValues: filterData.buckets.map((name) => {
                return {
                  dispValue: (Math.round(name.key * 10) / 10).toString() + '"',
                  units: name.doc_count,
                  checked: false,
                  groupType: null,
                  imageURL: null,
                };
              }),
            };
          } else {
            filterObj = {
              displayName: filterName.toLocaleLowerCase(),
              filterField: filterName.toLocaleLowerCase() + "_filter",
              fieldType: "checkbox",
              checked: false,
              displayMaxValues: "8",
              units: null,
              showCount: true,
              filterValues: filterData.buckets.map((name) => {
                return {
                  dispValue: name.key,
                  units: name.doc_count || 0,
                  checked: false,
                  groupType: null,
                  imageURL: null,
                };
              }),
            };
          }
          filterArr.push(filterObj);
          if (filterName.includes("Category") && !queryParams.category) {
            let categories = initProductCategories();
            if (categories.length == 0) {
              saveProductCategories(filterObj);
            }
          }
        })
    : false;

  filterArr.sort(function (a, b) {
    return a.filterDisplayOrder - b.filterDisplayOrder;
  });
  if (queryParams.gpu) {
    try {
      let previousFilterGroupCache = JSON.parse(
        localStorage.getItem("previousFilterGroupCache")
      );
      console.log("previousFilterGroupCache", previousFilterGroupCache);

      //let gpu_filter_objIndex = gpu_cache.filterValues.findIndex((obj => obj.dispValue == queryParams.gpu));
      //Log object to Console.
      //console.log("Before update: ", gpu_cache.filterValues[gpu_filter_objIndex]);
      //Update object's name property.
      //gpu_cache.filterValues[gpu_filter_objIndex].checked = true;
      if (previousFilterGroupCache != null) {
        let gpu_current_index = filterArr.findIndex(
          (x) => x.displayName === "gpu"
        );
        console.log(gpu_current_index);
        filterArr[gpu_current_index] = previousFilterGroupCache;
      }
    } catch (e) {}
    //localStorage.removeItem("previousFilterGroupCache");
    //localStorage.setItem("previousFilterGroupCache", JSON.stringify(filterArr));
  }
  return filterArr;
  // mergeDeep(state.productFilterSuperSet, filterArr)
}

function getValidProductFilters(
  filters,
  queryParams,
  state,
  categoryFilters,
  superFilters
) {
  console.log("getValidProductFilters");
  var filterArr = [];
  Object.keys(filters)
    .filter((key) => key != "totalCount")
    .map((key) => {
      let filterName = key.split("distinct")[1]
        ? key.split("distinct")[1]
        : key;
      //  let search = params.get(filterName);
      let filterData = filters[key];
      let filterObj = {};
      var superset = superFilters[key].buckets;

      if (filterName.includes("Category")) {
        var categorySuperset =
          state.productCategoriesSuperset &&
          state.productCategoriesSuperset.length &&
          state.productCategoriesSuperset[0].filterValues.length
            ? state.productCategoriesSuperset[0]
            : categoryFilters;
        let filtrData =
          filterData.buckets && filterData.buckets.length
            ? filterData.buckets.map((name) => {
                return {
                  dispValue: name.key,
                  units: name.doc_count,
                  checked: queryParams["category"] == name.key,
                  groupType: null,
                  imageURL: null,
                };
              })
            : categorySuperset &&
              categorySuperset.length &&
              categorySuperset.filterValues
            ? categorySuperset.filterValues.map((cat) => {
                return {
                  ...cat,
                  checked: queryParams["category"] == cat.dispValue,
                };
              })
            : superset && superset.length
            ? superset.map((cat) => {
                return {
                  ...cat,
                  checked: queryParams["category"] == cat.key,
                };
              })
            : [];

        filterObj = {
          displayName: "category",
          filterField: "category_filter",
          fieldType: "checkbox",
          checked: false,
          displayMaxValues: "8",
          units: null,
          showCount: false,
          filterDisplayOrder: 1,
          filterValues:
            categorySuperset && categorySuperset.filterValues
              ? categorySuperset.filterValues.map((val) => {
                  let concat = filtrData.filter(
                    (x) => x.dispValue == val.dispValue
                  );
                  return {
                    ...val,
                    ...concat[0],
                    checked: queryParams["category"] == val.dispValue,
                  };
                })
              : filtrData,
        };
      } else if (filterName.includes("MaxQSize")) {
        filterObj = {
          displayName: "max_q",
          filterField: "max_q_filter",
          fieldType: "checkbox",
          checked: true,
          displayMaxValues: "8",
          units: null,
          showCount: false,
          dataType: "Boolean",
          filterDisplayOrder: 8,
          filterValues:
            filterData.buckets && filterData.buckets.length
              ? [
                  {
                    dispValue: "1",
                    dispValueDesription: "max_q_description",
                    groupType: null,
                    units: filterData.buckets.filter((x) => x.key == 1)?.length
                      ? filterData.buckets.filter((x) => x.key == 1)[0]
                          .doc_count
                      : 0,
                    checked: queryParams["max_q"] ? true : false,
                    imageURL: null,
                  },
                ]
              : [],
        };
      } else if (filterName.includes("GroupFamily")) {
        let gpuFilters = [];
        let superGpuFilters = [];
        superset.map((outerBucket) => {
          return outerBucket.distinctProductFamilyName.buckets.map(
            (innerBucket) => {
              superGpuFilters.push({
                dispValue: innerBucket.key,
                dispValueDesription: null,
                groupType: outerBucket.key,
                units: 0 || innerBucket.doc_count,
                checked: queryParams["gpu"]
                  ? queryParams["gpu"].split(",").filter((key: string) => {
                      key == innerBucket.key;
                    }).length > 0
                  : false,
                imageURL: null,
              });
            }
          );
        });
        filterData.buckets.map((outerBucket) => {
          return outerBucket.distinctProductFamilyName.buckets.map(
            (innerBucket) => {
              gpuFilters.push({
                dispValue: innerBucket.key,
                dispValueDesription: null,
                groupType: outerBucket.key,
                units: 0 || innerBucket.doc_count,
                checked:
                  queryParams["gpu"] &&
                  queryParams["gpu"].includes(innerBucket.key),
                imageURL: null,
              });
            }
          );
        });
        filterObj = {
          displayName: "gpu",
          filterField: "gpu_filter",
          fieldType: "checkbox",
          checked: true,
          displayMaxValues: "8",
          units: null,
          showCount: false,
          // filterValues:gpuFilters,
          filterDisplayOrder: 2,
          filterValues:
            superGpuFilters &&
            superGpuFilters.length &&
            Object.keys(queryParams).length > 3
              ? superGpuFilters.map((val) => {
                  let concat = gpuFilters.filter(
                    (x) => x.dispValue == val.dispValue
                  );
                  console.log("concat", concat, "val", val);
                  return {
                    ...val,
                    units: queryParams["manufacturer"] ? 0 : val.units,
                    ...concat[0],
                  };
                })
              : gpuFilters,
        };
        superset;
        console.log(
          "superset",
          superset,
          "filterObj",
          filterObj,
          "filterData",
          filterData,
          "superGpuFilters",
          superGpuFilters
        );
      } else if (filterName.includes("ScreenSize")) {
        let filtrData =
          filterData.buckets && filterData.buckets.length
            ? filterData.buckets.map((name) => {
                return {
                  dispValue: (Math.round(name.key * 10) / 10).toString() + '"',
                  units: name.doc_count,
                  checked: queryParams["screen_size"]
                    ? queryParams["screen_size"].includes(
                        (Math.round(name.key * 10) / 10).toString() + '"'
                      )
                    : false,
                  groupType: null,
                  imageURL: null,
                };
              })
            : [];
        filterObj = {
          displayName: "screen_size",
          filterField: "screen_size_filter",
          fieldType: "checkbox",
          checked: false,
          displayMaxValues: "8",
          units: null,
          showCount: true,
          // filterValues:filtrData,
          filterDisplayOrder: 7,
          filterValues:
            superset && superset.length
              ? superset.map((val) => {
                  let concat = filtrData.filter(
                    (x) =>
                      x.dispValue ==
                      (Math.round(val.key * 10) / 10).toString() + '"'
                  );
                  return {
                    dispValue: (Math.round(val.key * 10) / 10).toString() + '"',
                    units: 0,
                    ...concat[0],
                    checked: queryParams["screen_size"]
                      ? queryParams["screen_size"].includes(
                          (Math.round(val.key * 10) / 10).toString() + '"'
                        )
                      : false,
                  };
                })
              : filtrData,
        };
      } else if (filterName.includes("Vram")) {
        let range = queryParams["vram"]
          ? queryParams["vram"].split(",")
          : [4, 48];
        filterObj = {
          displayName: "vram",
          filterField: "vram_filter",
          displayMaxValues: "8",
          fieldType: "range",
          selectedMinRangeVal: range[0],
          selectedMaxRangeVal: range[1],
          defaultMinRangeVal: 4,
          defaultMaxRangeVal: 48,
          unitsOfMeasure: null,
          checked: false,
          units: null,
          filterValues: null,
          dataType: "Double",
          showCount: true,
          filterDisplayOrder: 10,
        };
      } else if (filterName.includes("Manufacturer")) {
        let filtrData =
          filterData.buckets && filterData.buckets.length
            ? filterData.buckets.map((name) => {
                return {
                  dispValue: name.key,
                  units: name.doc_count,
                  checked: queryParams[filterName.toLocaleLowerCase()]
                    ? queryParams[filterName.toLocaleLowerCase()].includes(
                        name.key
                      )
                    : false,
                  groupType: null,
                  imageURL: null,
                };
              })
            : superset.map((val) => {
                return {
                  dispValue: val.key,
                  units: val.doc_count,
                  checked: queryParams[filterName.toLocaleLowerCase()]
                    ? queryParams[filterName.toLocaleLowerCase()].includes(
                        val.key
                      )
                    : false,
                  groupType: null,
                  imageURL: null,
                };
              });
        filterObj = {
          displayName: filterName.toLocaleLowerCase(),
          filterField: filterName.toLocaleLowerCase() + "_filter",
          fieldType: "checkbox",
          checked: false,
          displayMaxValues: "8",
          units: null,
          showCount: true,
          filterDisplayOrder: 3,
          // filterValues:filtrData
          filterValues:
            superset && superset.length && Object.keys(queryParams).length > 3
              ? superset.map((val) => {
                  let concat = filtrData.filter((x) => x.dispValue == val.key);
                  return {
                    dispValue: val.key,
                    units: 0,
                    ...concat[0],
                    checked: queryParams[filterName.toLocaleLowerCase()]
                      ? queryParams[filterName.toLocaleLowerCase()].includes(
                          val.key
                        )
                      : false,
                  };
                })
              : filtrData,
        };
      } else {
        let filtrData = filterData.buckets.map((name) => {
          return {
            dispValue: name.key,
            units: name.doc_count,
            checked: queryParams[filterName.toLocaleLowerCase()]
              ? queryParams[filterName.toLocaleLowerCase()].includes(name.key)
              : false,
            groupType: null,
            imageURL: null,
          };
        });
        filterObj = {
          displayName: filterName.toLocaleLowerCase(),
          filterField: filterName.toLocaleLowerCase() + "_filter",
          fieldType: "checkbox",
          checked: false,
          displayMaxValues: "8",
          units: null,
          showCount: true,
          filterDisplayOrder: 3,
          // filterValues:filtrData
          filterValues:
            superset[0] && superset[0].filterValues
              ? superset[0].filterValues.map((val) => {
                  let concat = filtrData.filter(
                    (x) => x.dispValue == val.dispValue
                  );
                  return {
                    ...val,
                    ...concat[0],
                  };
                })
              : filtrData,
        };
      }
      if (filterObj["filterValues"] && filterObj["filterValues"].length > 0) {
        filterArr.push(filterObj);
      } else if (filterName.includes("Vram")) {
        filterArr.push(filterObj);
      }
    });
  filterArr.sort(function (a, b) {
    return a.filterDisplayOrder - b.filterDisplayOrder;
  });
  if (queryParams.gpu) {
    try {
      let previousFilterGroupCache = JSON.parse(
        localStorage.getItem("previousFilterGroupCache")
      );
      console.log("previousFilterGroupCache", previousFilterGroupCache);
      if (previousFilterGroupCache != null) {
        var gpu_selected_fields = queryParams.gpu.split(",");
        for (var i = 0; i < previousFilterGroupCache.filterValues.length; i++) {
          previousFilterGroupCache.filterValues[i].checked = false;
        }
        gpu_selected_fields.forEach((element) => {
          let gpu_filter_objIndex =
            previousFilterGroupCache.filterValues.findIndex(
              (obj) => obj.dispValue == element
            );
          if (gpu_filter_objIndex != -1) {
            //Log object to Console.
            console.log(
              "Before update: ",
              previousFilterGroupCache.filterValues[gpu_filter_objIndex]
            );
            //Update object's name property.
            previousFilterGroupCache.filterValues[gpu_filter_objIndex].checked =
              true;
          }
        });
        let gpu_current_index = filterArr.findIndex(
          (x) => x.displayName === "gpu"
        );
        console.log(gpu_current_index);
        filterArr[gpu_current_index] = previousFilterGroupCache;
      }
    } catch (e) {}
    //localStorage.removeItem("previousFilterGroupCache");
    //localStorage.setItem("previousFilterGroupCache", JSON.stringify(filterArr));
  }
  return filterArr;
  // mergeDeep(state.productFilterSuperSet, filterArr)
}
function getValidFilterGroup(filters, state, queryparams, superfilters) {
  console.log("getValidFilterGroup");
  var filterArr = [];
  let previousFilterGroupCache = null;
  try {
    previousFilterGroupCache = JSON.parse(
      localStorage.getItem("previousFilterGroupCache")
    );
    console.log("previousFilterGroupCache", previousFilterGroupCache);
  } catch (e) {}
  if (queryparams.gpu && previousFilterGroupCache != null) {
    superfilters.buckets.map((set) => {
      let total_units = 0;
      previousFilterGroupCache.filterValues.forEach((element) => {
        if (set.key == element.groupType) {
          total_units = total_units + element.units;
        }
      });
      console.log("set", set);

      filterArr.push({
        ...set,
        displayName: set.key + "_group",
        filterField: set.key + "_group_filter",
        fieldType: "checkbox",
        units: total_units,
        checked: queryparams.gpu.split(",").filter((x) => set.key == x).length
          ? true
          : false,
      });
    });
    return filterArr;
  } else if (superfilters && superfilters.buckets.length) {
    superfilters.buckets.map((set) => {
      console.log("set", set);
      let newdata = filters.buckets.filter((x) => x.key == set.key);
      if (newdata && newdata.length) {
        let filterName = newdata[0].key;
        let filterObj = {
          ...set,
          displayName: filterName + "_group",
          filterField: filterName + "_group_filter",
          fieldType: "checkbox",
          checked:
            queryparams["gpu"] && queryparams["gpu"].includes(filterName),
          units: queryparams["manufacturer"]
            ? newdata[0].doc_count
            : set.doc_count,
        };
        filterArr.push(filterObj);
      } else {
        filterArr.push({
          ...set,
          displayName: set.key + "_group",
          filterField: set.key + "_group_filter",
          fieldType: "checkbox",
          units: queryparams["manufacturer"] ? 0 : set.doc_count,
        });
      }
    });
    return filterArr;
  } else if (filters && filters.buckets.length) {
    filters.buckets.map((value) => {
      let filterName = value.key;
      let filterObj = {
        displayName: filterName + "_group",
        filterField: filterName + "_group_filter",
        fieldType: "checkbox",
        checked:
          queryparams["gpu"] &&
          queryparams["gpu"].split(",").filter((key: string) => {
            return key == filterName;
          }).length > 0,
        units: value.doc_count,
        displayMaxValues: "8",
        filterValues: [],
      };
      filterArr.push(filterObj);
    });
    return filterArr;
  } else {
    return state.productFilterGroupSuperSet;
  }
}
function omit(obj, omitKey) {
  return Object.keys(obj).reduce((result, key) => {
    if (key !== omitKey) {
      result[key] = obj[key];
    }
    return result;
  }, {});
}

function getAllFilterValues(filterValues) {
  let filterValuesString = filterValues.map((filterValue) => {
    return filterValue.dispValue + "~" + filterValue.units;
  });
  return filterValuesString.join(",");
}

export const getProductFilterSuperSet = (state: ProductState) =>
  state.productFilterSuperSet;
export const getProductFilter = (state: ProductState) => state.productFilter;
export const getProductFilterGroup = (state: ProductState) =>
  state.productFilterGroup;
export const getProductSearch = (state: ProductState) => state.productSearch;
export const getProductSort = (state: ProductState) => state.productSort;
export const getProductFeatured = (state: ProductState) =>
  state.productFeatured;
export const getProductDetails = (state: ProductState) => state.productDetails;
export const getProductParams = (state: ProductState) => state.productParams;
export const getProductLoading = (state: ProductState) => state.productLoading;
export const getProductCompare = (state: ProductState) => state.productCompare;
export const getRetailInfo = (state: ProductState) => state.retailInfo;
export const getRetailInfoLoading = (state: ProductState) =>
  state.retailInfoLoading;
export const getGlobalHeader = (state: ProductState) => state.globalHeader;
export const getSubBrandHeader = (state: ProductState) => {
  return state.subBrandHeader;
};
export const getTotalProducts = (state: ProductState) => state.totalProducts;
export const getSuggestedProduct = (state: ProductState) =>
  state.suggestedProduct;
export const getLocale = (state: ProductState) => state.locale;
export const getCategory = (state: ProductState) =>
  state.productParams.category;
export const getCategorySuperset = (state: ProductState) =>
  state.productCategoriesSuperset;
export const getIsFeaturedProductIncludedInCount = (state: ProductState) =>
  state.isFeaturedProductIncludedInCount;
